<template>
  <div class="adminSidemenuNavbar">
    <div class="wrapper">
      <!-- adminSidemenu  -->
      <nav class="adminSidemenu">
        <div class="adminSidemenu-header">
          <div class="adminHeader">Admin Manage</div>
        </div>
        <ul class="list-unstyled components">
          <!-- Sidemenu Dropdown -->
          <!-- <li class="active">
            <a
              href="#homeSubmenu"
              data-toggle="collapse"
              aria-expanded="false"
              class="dropdown-toggle"
            >Home</a>
            <ul class="collapse list-unstyled" id="homeSubmenu">
              <li>
                <a href="#">Home 1</a>
              </li>
              <li>
                <a href="#">Home 2</a>
              </li>
              <li>
                <a href="#">Home 3</a>
              </li>
            </ul>
          </li> -->
          <li>
            <router-link to="/admin-manage" class="txt3" style="text-decoration:none;">Activity</router-link>
          </li>
          <li>
            <router-link to="/admin-manage/article" class="txt3" style="text-decoration:none;">Article</router-link>
          </li>
          <li>
            <router-link to="/admin-manage" class="txt3" style="text-decoration:none;">None</router-link>
          </li>
        </ul>
      </nav>

      <!-- Page adminNavbar  -->
      <div class="adminNavbar">
        <nav class="navbar">
          <div class="container-fluid">
            <button type="button" class="adminSidemenuCollapse btn">
              <i class="large material-icons icon-white">menu</i>
            </button>
            <ul class="nav ml-auto">
              <li class="nav-item active">
                <a class="nav-link" href="#">A</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">B</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">C</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">D</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidemenu",
  data() {
    return {};
  }
};
</script>

<style scoped>
.adminSidemenuNavbar a,
.adminSidemenuNavbar a:hover,
.adminSidemenuNavbar a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

.adminSidemenuNavbar a.nav-link {
  color: #fff;
}

.adminSidemenuNavbar .navbar {
  height: 70px;
  padding: 15px 10px;
  background: #333333;
  border: none;
  border-radius: 0;
  margin-top: 0;
  margin-bottom: 40px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

.adminSidemenuNavbar .navbar-btn {
  box-shadow: none;
  outline: none !important;
  border: none;
}

.adminSidemenuNavbar.line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #ddd;
  margin: 40px 0;
}

/* ---------------------------------------------------
        adminSIDEmenu STYLE
----------------------------------------------------- */

.adminSidemenuNavbar .wrapper {
  display: flex;
}

.adminSidemenuNavbar button:focus {
  box-shadow: 0 0 0 !important;
}

.adminSidemenuNavbar button:active {
  box-shadow: 0 0 0 !important;
}

.adminSidemenu {
  width: 250px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 999;
  background: #fff;
  color: #000;
  transition: all 0.3s;
}

.adminSidemenu.active {
  margin-left: -250px;
}

.adminSidemenu .adminSidemenu-header {
  height: 70px;
  padding: 8px;
  background: #333333;
}
.adminSidemenu .adminSidemenu-header .adminHeader {
  color: #fff;
  font-size: 30px;
  text-align: center;
  line-height: 50px;
}

.adminSidemenu ul.components {
  padding: 0;
}

.adminSidemenu ul p {
  color: #fff;
  padding: 10px;
}

.adminSidemenu ul li a {
  padding: 20px 40px;
  font-size: 1.1em;
  display: block;
  transition: padding 0s;
}

.adminSidemenu ul li a:hover {
  border-left: 6px #555555 solid;
  padding-left: 34px;
}

.adminSidemenu ul li.active > a,
a[aria-expanded="true"] {
  color: #000;
  background: #6d7fcc;
}

a[data-toggle="collapse"] {
  position: relative;
}

.adminSidemenuNavbar .dropdown-toggle::after {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.adminSidemenuNavbar ul ul a {
  font-size: 0.9em !important;
  padding-left: 30px !important;
  background: #6d7fcc;
}

.adminSidemenuNavbar ul.CTAs {
  padding: 20px;
}

.adminSidemenuNavbar ul.CTAs a {
  text-align: center;
  font-size: 0.9em !important;
  display: block;
  border-radius: 5px;
  margin-bottom: 5px;
}

.adminSidemenuNavbar a.download {
  background: #000;
  color: #fff;
}

.adminSidemenuNavbar a.article,
.adminSidemenuNavbar a.article:hover {
  background: #6d7fcc !important;
  color: #fff !important;
}

.adminSidemenuNavbar i.icon-white {
  color: white;
}

/* ---------------------------------------------------
        adminNavbar STYLE
----------------------------------------------------- */

.adminNavbar {
  width: calc(100% - 250px);
  min-height: 100vh;
  transition: all 0.3s;
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ebebeb;
}

.adminNavbar.active {
  width: 100%;
}

.adminNavbar .material-icons {
  line-height: unset;
}

/* ---------------------------------------------------
        MEDIAQUERIES
----------------------------------------------------- */

@media (max-width: 768px) {
  .adminSidemenu {
    margin-left: -250px;
  }
  .adminSidemenu.active {
    margin-left: 0;
  }
  .adminNavbar {
    width: 100%;
  }
  .adminNavbar.active {
    width: calc(100% - 250px);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/admin-manage/Sidemenu.vue